import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
import './ProductsTypeSwicth.css';

type Props = {
    value: boolean[];
    onChange: (value: boolean[]) => void;
};

const ProductsTypeSwicth: FC<Props> = ({ value, onChange }) => {
	const { t } = useTranslation();
    const [ stm, brand, dist ] = value;

    return (
        <div className='ProductsTypeSwicth'>
            <div onClick={() => onChange([ !stm, brand, dist ])}>
                <Icon icon={stm ? faSquareCheck : faSquare}/>&nbsp;
                {t(`attendee.products_type_stm`)}
            </div>
            <div onClick={() => onChange([ stm, !brand, dist ])}>
                <Icon icon={brand ? faSquareCheck : faSquare}/>&nbsp;
                {t(`attendee.products_type_brand`)}
            </div>
            <div onClick={() => onChange([ stm, brand, !dist ])}>
                <Icon icon={dist ? faSquareCheck : faSquare}/>&nbsp;
                {t(`attendee.products_type_dist`)}
            </div>
        </div>
    );
};

export default ProductsTypeSwicth;
